<div class="spinner-wrapper">
  <p-progressSpinner strokeWidth="4" animationDuration=".8s" *ngIf="show"></p-progressSpinner>
</div>
